<template>
  <v-card :flat="flat">
    <v-card-title v-if="!hideTitle">
      <h3
        class="grey--text text--darken-3"
        :class="titleClasses"
      >
        {{ $t('privacyDialogTitle') }}
      </h3>
    </v-card-title>
    <v-divider v-if="!hideTitle" />
    <v-card-text :class="{'pa-0': noPadding}">
      <v-layout
        align-start
        :wrap="$vuetify.breakpoint.xsOnly"
      >
        <div>
          <v-layout
            class="pa-2 clickable"
            align-center
            @click="$emit('update:accepted', !accepted)"
          >
            <v-checkbox
              :input-value="accepted"
              hide-details
              style="flex: 0"
              color="msr"
              class="mt-0 mr-2"
            />
            <div>
              {{ $t('privacySignupText_1') }}
              <a
                :href="$store.state.common.dataPrivacyURL"
                target="_blank"
                @click.stop
              >{{ $t('privacyPolicy') }}</a>
              {{ $t('and') }}
              <a
                :href="$store.state.common.generalTermsAndConditionsUrl"
                target="_blank"
                @click.stop
              >{{ $t('privacySignupText_GTC') }}</a>
              {{ $t('privacySignupText_2') }}
              {{ $t('privacySignupText_3') }}
            </div>
          </v-layout>
          <div class="ml-5">
            <small>
              {{ $t('privacySignupText_4') }}
              <span
                class="anchor"
                @click.stop="mailTo(supportEmail)"
              >{{
                supportEmail
              }}</span>
              {{ $t('privacySignupText_5') }}
              {{ $t('privacyPolicy') + '.' }}
            </small>
          </div>
        </div>
      </v-layout>
      <slot name="extra" />
    </v-card-text>
    <v-card-actions v-if="showActions">
      <slot name="actions" />
    </v-card-actions>
  </v-card>
</template>

<script>
import {SUPPORT_EMAIL} from '@/store';

export default {
  props: {
    accepted: {
      type: Boolean,
      required: true,
    },
    showActions: {
      type: Boolean,
      default: false,
    },
    flat: {
      type: Boolean,
      default: false,
    },
    hideTitle: {
      type: Boolean,
      default: false,
    },
    noPadding: {
      type: Boolean,
      default: false,
    },
    titleClasses: {
      type: Array[String],
      default: () => ['body-2'],
    },
  },
  data() {
    return {
      supportEmail: SUPPORT_EMAIL,
    };
  },
  methods: {
    mailTo(email) {
      location.href = `mailto:${email}`;
    },
  },
};
</script>

<style></style>

<style scoped>
.anchor {
  color: var(--msr-color-primary);
  text-decoration: underline;
  pointer-events: initial;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/DsgvoCompliance.vue